'use strict';

/**
 * List item for the unfinished export list
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/export-unfinished-list-item.hbs');

var ExportUnfinishedListItem = ColidoItemView.extend({
    template: template,

    tagName: 'li',

    modelEvents: {
        'change sync': 'render',
    },
});

module.exports = ExportUnfinishedListItem;